// 组件
export enum AccountMenuEnum {
    Home = "home",
    Enterprise = "enterprise",
    Records = "records",
    Consumption = "consumption",
    Glossary = "glossary",
    Orders = "orders",
    Combo = "combo",
    ExitLogin = "ExitLogin",
}
// 不是组件
export enum AccountMenuHandleEnum {
    MemberCode = "MemberCode",
    ExitLogin = "ExitLogin",
}

export interface IAccountMenu {
    icon: string | null,
    name: string | null,
    path?: string,
    isDivider?: boolean,
    handleType?: AccountMenuHandleEnum,
    component?: AccountMenuEnum,
}

export const useAccountMenu = () => {
    const { t } = useI18n()
    const localePath = useLocalePath()
    
    // 使用 computed 来响应式获取菜单项
    const menu = computed<IAccountMenu[]>(() => [
        { icon: null, name: null, isDivider: true },
        {   icon: 'icon-icon_home', name: t('account_menu_home'), path: localePath(`/account?menu=${AccountMenuEnum.Home}`), 
            component: AccountMenuEnum.Home    
        },
        {   icon: 'icon-icon_enterprisemanagement', name: t('account_menu_enterprise'),path: localePath(`/account?menu=${AccountMenuEnum.Enterprise}`), 
            component: AccountMenuEnum.Enterprise 
        },
        {   icon: 'icon-icon_user', name: t('account_menu_translate'), path: localePath(`/account?menu=${AccountMenuEnum.Records}`), 
            component: AccountMenuEnum.Records 
        },
        {   icon: 'icon-icon_History', name: t('account_menu_cost'), path: localePath(`/account?menu=${AccountMenuEnum.Consumption}`), 
            component: AccountMenuEnum.Consumption 
        },
        {   icon: 'icon-icon_glossary', name: t('account_menu_art'), path: localePath(`/account?menu=${AccountMenuEnum.Glossary}`), 
            component: AccountMenuEnum.Glossary 
        },
        {   icon: 'icon-icon_selectpage', name: t('account_menu_orders'), path: localePath(`/account?menu=${AccountMenuEnum.Orders}`), 
            component: AccountMenuEnum.Orders 
        },
        {   icon: 'icon-icon_business_plan', name: t('account_menu_combo'), path: localePath(`/account?menu=${AccountMenuEnum.Combo}`), 
            component: AccountMenuEnum.Combo 
        },
        {   icon: 'icon-icon_exit', name: t('account_to_route_title_6'), component: AccountMenuEnum.ExitLogin,
            handleType: AccountMenuHandleEnum.ExitLogin
        }
    ])

    return {
        menu
    }
}